import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

/**
 * Dropdown menu separator
 *
 * @example
 *   <DropdownMenuSeparator />
 */
const DropdownMenuSeparator = styled.div`
  margin: 3px 12px;
  height: 1px;
  background: ${withVar(DesignToken.BorderBasicSecondary)};
`;

export default DropdownMenuSeparator;
